module.exports = __webpack_public_path__ + "img/shopvideo-location.76afe100.png";